<template>
  <el-card shadow="hover" class="chart-card bottom-card">
    <div slot="header" class="card-header">
      <span>{{ title || '人效分析 Monitoramento da eficiência de coleta de estado' }}</span>
      <img
        :src="exportIcon" class="export-btn" alt="导出"
        @click="handleExport"
      >
    </div>
    <div class="personnel-stats">
      <div class="stat-row">
        <div class="stat-box light-green">
          <div class="stat-corner">
            <div class="icon-bg">
              <img :src="icon1" class="corner-icon" alt="icon">
            </div>
          </div>
          <div class="stat-label">上岗人数 Numero de pessoas no posto</div>
          <div class="stat-val">{{ data.staffCount || 0 }}</div>
        </div>
        <div class="stat-box light-blue">
          <div class="stat-corner">
            <div class="icon-bg">
              <img :src="icon2" class="corner-icon" alt="icon">
            </div>
          </div>
          <div class="stat-label">揽收票数 Numero de votos coletados</div>
          <div class="stat-val">{{ data.collectCnt || 0 }}</div>
        </div>
      </div>
      <div class="stat-row">
        <div class="stat-box light-yellow">
          <div class="stat-corner">
            <div class="icon-bg">
              <img :src="icon3" class="corner-icon" alt="icon">
            </div>
          </div>
          <div class="stat-label">平均人效 Numero de pessoas no posto</div>
          <div class="stat-val">{{ averageEfficiency }}</div>
        </div>
        <div class="stat-box transparent">
          <div class="cache-time">缓存: {{ cacheTime }}</div>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'PersonnelEfficiencyStats',
  props: {
    title: {
      type: String,
      default: ''
    },
    cacheTime: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: () => ({
        staffCount: 0,
        collectCnt: 0,
        efficiencyRate: 0
      })
    }
  },
  data() {
    return {
      exportIcon: require('@/assets/images/kanban/endKanbanBoard/Export.svg'),
      icon1: require('@/assets/images/kanban/endKanbanBoard/Human-performance-analysis-icon-1.svg'),
      icon2: require('@/assets/images/kanban/endKanbanBoard/Human-performance-analysis-icon-2.svg'),
      icon3: require('@/assets/images/kanban/endKanbanBoard/Human-performance-analysis-icon-3.svg')
    };
  },
  computed: {
    averageEfficiency() {
      const { collectCnt, staffCount, efficiencyRate } = this.data;
      // 如果有员工数且大于0，计算平均人效
      if (staffCount && staffCount > 0) {
        return Math.round(collectCnt / staffCount);
      }
      // 否则使用返回的efficiencyRate
      return efficiencyRate || 0;
    }
  },
  methods: {
    /**
     * 处理导出
     */
    handleExport() {
      this.$emit('export');
    }
  }
};
</script>

<style scoped lang="scss">
.chart-card {
  margin-bottom: 0;
  height: 100%;
  background: #ffffff;
  border-radius: 12px;
  border: none;

  ::v-deep .el-card__header {
    border-bottom: none;
    padding-bottom: 0;
  }

  ::v-deep .el-card__body {
    padding: 20px;
  }

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: Alibaba PuHuiTi 2, Alibaba PuHuiTi 20;
    font-size: 16px;
    color: #0f1728;
    font-style: normal;
    text-transform: none;
    font-weight: bold;
    .export-btn {
      width: 16px;
      height: 16px;
      cursor: pointer;
      transition: opacity 0.3s;

      &:hover {
        opacity: 0.7;
      }
    }
  }
}

.personnel-stats {
  display: flex;
  flex-direction: column;
  gap: 15px;
  height: 250px;
  justify-content: center;

  .stat-row {
    display: flex;
    gap: 15px;
    flex: 1;
  }

  .stat-box {
    flex: 1;
    border-radius: 4px;
    padding: 15px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden;

    &.light-green {
      background: #f9f9f9;
    }
    &.light-blue {
      background: #f9f9f9;
    }
    &.light-yellow {
      background: #f9f9f9;
    }
    &.transparent {
      background: transparent;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
    }

    .stat-corner {
      position: absolute;
      top: 0;
      right: 0;
      width: 92px;
      height: 52px;
      border-radius: 0 4px 0 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 5px;
      padding-right: 5px;
      z-index: 0;

      .icon-bg {
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 6px;
      }

      .corner-icon {
        width: 20px;
        height: 20px;
      }
    }

    &.light-green .stat-corner {
      background: #ebfdf6;

      .icon-bg {
        background: #cdfbe4;
      }
    }

    &.light-blue .stat-corner {
      background: #eff6ff;

      .icon-bg {
        background: #dbeafe;
      }
    }

    &.light-yellow .stat-corner {
      background: #fefbea;

      .icon-bg {
        background: #fdf2c5;
      }
    }

    .stat-label {
      font-size: 12px;
      color: #666;
      margin-bottom: 5px;
      position: relative;
      z-index: 1;
    }
    .stat-val {
      font-size: 24px;
      font-weight: bold;
      color: #333;
    }
    .stat-icon {
      position: absolute;
      right: 15px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 24px;
      opacity: 0.5;
    }

    .cache-time {
      color: #999;
      font-size: 12px;
    }
  }
}
</style>
